var site = site || {};
site.bundleflow = site.bundleflow || {};

(function($, scope) {

  /*
   * BundleFlowState is a minimal bundle state / dom update class. For the most
   * part, it will not handle updating the dom except for minor isolated
   * changes like:
   * 1. disable/renabling add to cart button
   * 2. Any step indicators.
   *
   * So in the case of the bundle overlay, the switching between steps is
   * handled outside of this JS since not everyone will want the same type of
   * step switching or even having a single step modal.
   *
   * This class also emits events:
   * bundle_sku_selected
   * next_cta_click
   *
   * todo: Ideally BundleFlowState would have 0 dom interactions and be split
   * up into 2 classes.
   */
  function BundleFlowState($flow) {
    this.init($flow);
  }

  BundleFlowState.prototype.init = function($flow) {
    if ($flow.data('bundle-flow')) {
      throw new Error('Already created BundleFlowState for this DOM');
    }

    this.step_selector = '[data-step-id][data-step-datasource]';
    this.cta_selector = '.js-bundle-next-cta';

    this._flow_steps = {};
    this._flow_state = {};

    this.bind_dom_nodes($flow);
    this.gather_bundle_data();
    this.attach_handlers();

    this.set_initial_state();
  };

  BundleFlowState.prototype.reset_state = function() {
    this.set_initial_state();
  };

  /*
   * Utility function to iterate over steps
   */
  BundleFlowState.prototype.foreachStepState = function(func) {
    var self = this;
    var options = this.options || {};
    $.each(this._flow_steps, function(step_id, step) {
      var state = self.get_state_from_id(step_id) || {};
      func(step_id, step, state, options);
    });
  };

  BundleFlowState.prototype.set_initial_state = function() {
    var self = this;

    // prep empty state first
    this.foreachStepState(function(i, step, state) {
      self._flow_state[step.step_id] = {}; // reset state for step
    });

    this.foreachStepState(function(i, step, state) {
      var product_id = step.product_id;
      if (!product_id) {
        return;
      }
      var prodData = prodcat.data.getProduct(product_id);

      if (!prodData['shaded']) {
        self.selectSku(prodData.defaultSku.SKU_ID, step.step_id);
      }
    });
  };

  BundleFlowState.prototype.bind_dom_nodes = function($flow) {
    this.$flow = $flow;
    this.$flow.data('bundle-flow', this);
    this.$steps = $(this.step_selector, $flow);
    this.$addBtn = $('.js-add-to-cart, .js-add-to-bag', $flow);
  };

  BundleFlowState.prototype.selectSku = function(skuBaseId, step_id) {
    var state = this.get_state_from_id(step_id);
    var sku = prodcat.data.getSku(skuBaseId);
    state['selectedSku'] = sku['SKU_BASE_ID'];

    this.updateView();
    $(this).trigger('bundle_sku_selected', [step_id, sku['SKU_BASE_ID']]);
  };

  /*
   * Checks whether all steps are complete and bundle can be added to cart
   */
  BundleFlowState.prototype.is_complete = function() {
    var self = this;
    var complete = true;
    this.foreachStepState(function(step_id, step, state) {
      if (!self.is_step_complete(step_id)) {
        complete = false;
        return;
      }
    });
    return complete;
  };

  /*
   * If a step is complete and can be continued. Only product steps can return
   * is false if the product is shaded and hasn't had a sku selected.
   */
  BundleFlowState.prototype.is_step_complete = function(step_id) {
    var state = this.get_state_from_id(step_id);
    var step = this.get_step_from_id(step_id);

    if (!step.required) {
      return true;
    }

    if (step.required && state.selectedSku) {
      return true;
    }
    return false;
  };

  /*
   * Grab Bundle Flow related data from dom. Kind of want to just output a json
   * blog insted of grabbing data from dom elements. todo?
   */
  BundleFlowState.prototype.gather_bundle_data = function() {
    var self = this;
    var $flow = this.$flow;

    var options = {};
    options['bundle_show_price'] = !!$flow.data('bundle-show-price');
    options['bundle_show_size'] = !!$flow.data('bundle-show-size');

    this.options = options;

    var last_steps = [];
    var steps = [];

    this.$steps.each(function(i, obj) {
      var $step = $(obj);
      var step_id = $step.data('step-id');
      var step_order = $step.data('step-order');
      var product_id = $step.data('product-id');

      var step_data = {
        step_id: step_id,
        '$dom': $step,
        _stepOrder: step_order,
      };

      if (product_id) {
        var prodData = prodcat.data.getProduct(product_id);
        step_data['required'] = true;
        step_data['product_id'] = product_id;
        step_data['shaded'] = !!prodData['shaded'];
      }

      // for now step order can be last or undefined
      // undefined will just order by how they show up in dom.
      if (step_order == 'last') {
        last_steps.push(step_data);
      } else {
        steps.push(step_data);
      }
      self._flow_steps[step_id] = step_data;
    });

    var ordered_steps = steps.concat(last_steps);
    $.each(ordered_steps, function(i, obj) {
      obj['step_order'] = i;
    });

    self.ordered_steps = ordered_steps;
  };

  /*
   * Access state by step-id.
   */
  BundleFlowState.prototype.get_state_from_id = function(step_id) {
    var state = this._flow_state[step_id];
    return state;
  };

  /*
   * Access step by step-id.
   */
  BundleFlowState.prototype.get_step_from_id = function(step_id) {
    var step = this._flow_steps[step_id];
    return step;
  };

  /*
   * Access step by ordinal index.
   */
  BundleFlowState.prototype.index_step = function(step_index) {
    return this.ordered_steps[step_index];
  };

  /*
   * Based on a dom element, return the step that corresponds to that element.
   * Akin to the getProductEl logic.
   */
  BundleFlowState.prototype.get_step_from_dom = function($el) {
    var step = null;
    if ($el.data('step-id')) {
      step = this.get_step_from_id($el.data('step-id'));
      return step;
    }
    var $step = $el.closest(this.step_selector);
    if ($step.data('step-id')) {
      step = this.get_step_from_id($step.data('step-id'));
      return step;
    };
  };

  BundleFlowState.prototype.attach_handlers = function() {
    var self = this;

    // Handle clicks on next-ctas and if the user is able to move on
    // send an event to notify
    this.$flow.on('click', this.cta_selector, function(e) {
      var $button = $(this);
      e.preventDefault();
      var step = self.get_step_from_dom($button);
      var state = self.get_state_from_id(step.step_id);
      if (self.is_step_complete(step.step_id)) {
        $(self).trigger('next_cta_click', [$button, step, state])
      }
    });

    // largely to capture the skuSelect from swatchlists
    this.$flow.on('product.skuSelect', this.step_selector, function(e, skuBaseId, url_hit) {
      var $step = $(this);
      self.handle_sku_select(e, skuBaseId, $step);
    });
  };

  // handles product.skuSelect
  BundleFlowState.prototype.handle_sku_select = function(e, skuBaseId, $step) {
    var step = this.get_step_from_dom($step);
    this.selectSku(skuBaseId, step['step_id']);
  };

  /*
   * DOM Mutation Methods
   */
  BundleFlowState.prototype.updateView = function() {
    this.updateAddButton();
    this.updateSteps();
  };

  /*
   * Update step based dom elements
   */
  BundleFlowState.prototype.updateSteps = function() {
    var self = this;
    this.foreachStepState(function(step_id, step, state) {
      var $step = step['$dom'];
      if (state.selectedSku) {
        self.setStepClass(step_id, 'bundle-sku-selected');
      } else {
        self.removeStepClass(step_id, 'bundle-sku-selected');
      }

      var $next_cta = $('.js-bundle-next-cta', $step);
      var step_complete = self.is_step_complete(step_id);
      self.toggleButton($next_cta, step_complete);
    });
  };

  BundleFlowState.prototype.removeStepClass = function(step_id, cls) {
    var step = this.get_step_from_id(step_id);
    var $step = step['$dom'];
    $step.removeClass(cls);
    var $step_indicators = $('.js-bundle-step-indicator[data-step-id="'+step_id+'"]', self.$flow);
    $step_indicators.removeClass(cls);
  };

  /*
   * Utility function to add classes to steps.
   */
  BundleFlowState.prototype.setStepClass = function(target_step_id, cls, single) {
    var self = this;
    single = !!single;
    if (single) { // this unsets the class from other steps
      this.foreachStepState(function(step_id, step, state) {
        if (step.step_id != target_step_id) {
          self.removeStepClass(step.step_id, cls);
        }
      });
    }

    // now add the class to the right one.
    var state = this.get_state_from_id(target_step_id);
    var step = this.get_step_from_id(target_step_id);
    var $step = step.$dom;
    $step.addClass(cls);
    var $step_indicators = $('.js-bundle-step-indicator[data-step-id="'+target_step_id+'"]', self.$flow);
    $step_indicators.addClass(cls);
  };

  /*
   * Update the final add to cart button.
   */
  BundleFlowState.prototype.updateAddButton = function() {
    var $addBtn = this.$addBtn;

    var selected_skus = [];
    if($addBtn.data("skuBaseId")) {
      selected_skus.push($addBtn.data("skuBaseId"));
    }
    this.foreachStepState(function(step_id, step, state) {
      if (state.selectedSku) {
        selected_skus.push(state.selectedSku);
      }
    });

    var skus_string = selected_skus.join(',');
    if ($addBtn.data('kit-type') == 'MULTIADD') {
      // multi add uses the normal sku-base-id stuff.
      $addBtn.data('sku-base-id', skus_string);
    } else {
      $addBtn.data('kit-skus', skus_string);
    }
    this.toggleButton($addBtn, this.is_complete());
  };

  /*
   * Quick util to toggle button using js states.
   */
  BundleFlowState.prototype.toggleButton = function($button, enabled) {
    if (!$button.is('.button')) {
      $button = $('.button', $button);
    }
    if (enabled) {
      $button.removeClass('button--disabled').data('disabled', false);
    } else {
      $button.addClass('button--disabled').data('disabled', true);
    }
  };

  scope.BundleFlowState = BundleFlowState;

})(jQuery, site.bundleflow);
